import React from "react";
import PropTypes from "prop-types";
import BaseBlock from "./BaseBlock";
import useBlockData from "./useBlockData";
import VarianceWaterfallChart from "../charts/VarianceWaterfallChart";

/**
 * VarianceWaterfallBlock - MoM variance waterfall (variance_waterfall block type).
 *
 * GET /api/v1/board-reports/{boardReportId}/runs/{runId}/figures/pvm -> envelope key "pvm"
 * -> boardfigures.PVM { prev_label, prev_total, steps: [{label, kind, delta, volume, rate,
 * category}], current_label, current_total, drivers } (SP2-T3, internal/boardfigures - the
 * segmented Price/Volume/Mix shape). Note the envelope key is "pvm", NOT "waterfall" - easy
 * to get wrong since the block used to unwrap "waterfall" pre-SP2. Rendering (bar layout,
 * Volume/Rate split, empty state) is entirely VarianceWaterfallChart's job (Task 5) - this
 * block only fetches and unwraps the envelope, mirroring StackedTrendBlock/
 * PerformanceTableBlock's fetch pattern.
 */
const VarianceWaterfallBlock = ({ title = "Variance waterfall", boardReportId, runId }) => {
  const { data, isLoading, error } = useBlockData(
    `/api/v1/board-reports/${boardReportId}/runs/${runId}/figures/pvm`
  );

  return (
    <BaseBlock title={title} isLoading={isLoading} error={error} className="a4-variance-waterfall">
      <VarianceWaterfallChart data={data?.pvm ?? null} />
    </BaseBlock>
  );
};

VarianceWaterfallBlock.propTypes = {
  title: PropTypes.string,
  boardReportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  runId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default VarianceWaterfallBlock;
